// src/pages/dashboard/section-observation/SectionObservation.jsx
import React, { useState } from "react";
import { 
    Paper, 
    Stack, 
    Typography, 
    Box,
    Tabs,
    Tab,
    Card,
    CardContent
} from "@mui/material";
import YardOutlinedIcon from '@mui/icons-material/YardOutlined';
import ReportBuahAlami from "../../drone/buah-alami/ReportBuahAlami";

function SectionObservation({ paperShadow }) {
    // State untuk tab aktif
    const [currentTab, setCurrentTab] = useState(0);

    // Fungsi untuk handle perubahan tab
    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    // Data tab dengan label dan count (untuk konsistensi dengan BuahAlami)
    const tabs = [
        { label: "Buah Alami", value: 0, count: 0 },
        { label: "Berat Tanaman", value: 1, count: 0 },
        { label: "Persen Bunga", value: 2, count: 0 }
    ];

    // Konten untuk setiap tab
    const renderTabContent = () => {
        switch (currentTab) {
            case 0:
                return <ReportBuahAlami />;
            case 1:
                return (
                    <Typography variant="body1" color="text.primary">
                        Konten Berat Tanaman akan ditampilkan di sini.
                    </Typography>
                );
            case 2:
                return (
                    <Typography variant="body1" color="text.primary">
                        Konten Persen Bunga akan ditampilkan di sini.
                    </Typography>
                );
            default:
                return (
                    <Typography variant="body1" color="text.primary">
                        Konten Observation akan ditampilkan di sini.
                    </Typography>
                );
        }
    };

    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                boxShadow: paperShadow,
            }}
        >
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
                <YardOutlinedIcon sx={{ fontSize: 32, color: "#FFC107" }} />
                <Box>
                    <Typography variant="h6" fontWeight="bold">
                        Observation
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Deskripsi
                    </Typography>
                </Box>
            </Stack>

            {/* Card untuk konten dengan tab */}
            <Card sx={{ width: "100%", overflow: "hidden", borderRadius: 1, boxShadow: 0, pb: 0 }}>
                <CardContent 
                    sx={{ 
                        p: 0, 
                        // Menghilangkan padding-bottom dengan !important
                        pb: '0 !important',
                        // Untuk kompatibilitas dengan MUI CSS classes
                        '&.MuiCardContent-root:last-child': {
                            pb: '0 !important'
                        }
                    }}
                >
                    {/* Tabs - styling seperti di BuahAlami.jsx */}
                    <Box sx={{ border: 1, borderColor: 'divider', backgroundColor:'#f2f9ff', px: 0, pb: 0 }}>
                        <Tabs
                            value={currentTab}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{
                                minHeight: '48px',
                                '& .MuiTab-root': {
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    fontSize: '0.875rem',
                                    py: 1.5,
                                    px: 2,
                                    minHeight: '48px',
                                    minWidth: 'auto',
                                    position: 'relative',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                    }
                                },
                                '& .Mui-selected': {
                                    fontWeight: 600,
                                    color: 'primary.main',
                                },
                                '& .MuiTabs-indicator': {
                                    backgroundColor: 'primary.main',
                                    height: 3,
                                    borderRadius: '3px 3px 0 0',
                                }
                            }}
                        >
                            {tabs.map((tab) => (
                                <Tab 
                                    key={tab.value} 
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <span>{tab.label}</span>
                                            {tab.count > 0 && (
                                                <Box
                                                    sx={{
                                                        backgroundColor: 'action.selected',
                                                        borderRadius: '12px',
                                                        px: 1,
                                                        py: 0.25,
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500,
                                                        minWidth: '24px',
                                                        display: 'inline-flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    {tab.count}
                                                </Box>
                                            )}
                                        </Box>
                                    }
                                />
                            ))}
                        </Tabs>
                    </Box>

                    {/* Konten Tab */}
                    <Box sx={{ p: 0, pt:2 }}>
                        {renderTabContent()}
                    </Box>
                </CardContent>
            </Card>
        </Paper>
    );
}

export default SectionObservation;